import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AuthStore } from '@store';

@Component({
  selector: 'app-event-banner',
  templateUrl: './event-banner.component.html',
  styleUrls: ['./event-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventBannerComponent {
  constructor(public authStore: AuthStore) {}

  close(): void {
    this.authStore.closeEventBanner();
  }
}
